/* eslint-disable max-len */
/* NOTE:
 * Use this tool: https://www.smooth-code.com/open-source/svgr/playground/
 * to convert the SVG file and copy the more compact version inside the generated
 * <svg> and place it in the Google Lit's svg TemplateResult variable
 * Also remember to replace all hard coded colors with `currentColor`
 * in order to make it possible to change the color dynamically.
 *
 * The default viewport is '0 0 24 24' but you can change it in TeSvg generation
 * by passing the value of a custom viewport to the constructor if the SVG
 * being added does not match the default viewport
 * EXAMPLE: new TeSvg(<path></path>, '0 0 50 50');
 */

import { svg, TemplateResult } from 'lit';

interface NewSvg {
  path: TemplateResult;
  viewport?: string;
  style?: string;
}

export class TeSvg {
  path: TemplateResult;
  viewport: string;
  style: string;
  constructor(svg: NewSvg) {
    this.path = svg.path;
    this.viewport = svg.viewport || '0 0 24 24';
    this.style = svg.style || '';
  }
}

const angledMenu = new TeSvg({
  path: svg`
    <path
      d="M1.5 17.5v2h22v-2h-22m0-6v2h18v-2h-18m0-6v2h14v-2h-14"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth=0.3
      fillRule="evenodd"
    ></path>
  `,
});

const previous = new TeSvg({
  path: svg`
    <g id="Group_4855" transform="translate(-637.111 63)" fillRule="evenodd"  fill="currentColor"
      stroke="currentColor">
	    <path id="acc-down" class="st0" d="M661.11-58.51L653.69-51l7.42,7.51l-2.28,2.31L649.11-51l9.72-9.82L661.11-58.51z"/>
	    <path id="acc-down-2" class="st0" d="M649.11-58.51L641.69-51l7.42,7.51l-2.28,2.31L637.11-51l9.72-9.82L649.11-58.51z"/>
    </g>
  `,
});

const next = new TeSvg({
  path: previous.path,
  style: 'transform: rotate(180deg);',
});

const chevronLeft = new TeSvg({
  path: svg`
    <path
      d="M15.89 23.51L5.72 12.81c-.43-.46-.43-1.17 0-1.63L15.89.48c.58-.62 1.55-.66 2.17-.08l.08.08c.62.67.62 1.69 0 2.36L9.44 12l8.7 9.15c.62.67.62 1.7 0 2.36-.58.62-1.55.66-2.17.08l-.08-.08"
      fill="currentColor"
    ></path>
  `,
});
const chevronRight = new TeSvg({
  path: chevronLeft.path,
  style: 'transform: rotate(180deg);',
});
const chevronUp = new TeSvg({
  path: chevronLeft.path,
  style: 'transform: rotate(90deg);',
});
const chevronDown = new TeSvg({
  path: chevronLeft.path,
  style: 'transform: rotate(270deg);',
});

const pageNotFound = new TeSvg({
  path: svg`
    <g>
      <path
        d="M4.23 8.88v3.47H1.6l2.58-3.47h.05zm0 5.15v2.31h1.93v-2.31h1.33v-1.67H6.16V6.35H4.35L.01 12.18v1.86h4.22zm16.51-5.15v3.47h-2.63l2.58-3.47h.05zm0 5.15v2.31h1.93v-2.31H24v-1.67h-1.33V6.35h-1.81l-4.34 5.83v1.86h4.22z"
        fill="#f1f1f1"
      ></path>
      <path
        d="M18.72 16.47l-2.83-2.83a.461.461 0 00-.51-.09 4.453 4.453 0 00-.75-6.25 4.453 4.453 0 00-6.25.75 4.453 4.453 0 00.75 6.25 4.446 4.446 0 005.5 0c-.08.17-.04.38.09.51l2.83 2.83c.18.18.46.18.64 0l.53-.53c.16-.18.16-.46 0-.64zm-6.84-2.97c-1.65 0-2.7-1.06-2.7-2.7s1.06-2.7 2.7-2.7 2.7 1.06 2.7 2.7c0 1.64-1.05 2.7-2.7 2.7z"
        fill="currentColor"
      ></path>
    </g>
  `,
});

const resources = new TeSvg({
  path: svg`
    <path
      d="M21 6H9c-.6 0-1 .4-1 1v10c0 .6.4 1 1 1h12c.6 0 1-.4 1-1V7c0-.6-.4-1-1-1zM6 6H3c-.6 0-1 .4-1 1v10c0 .6.4 1 1 1h3c.6 0 1-.4 1-1V7c0-.6-.4-1-1-1z"
      fill="currentColor"
    ></path>
  `,
});

const close = new TeSvg({
  path: svg`
    <g transform="translate(-7 -1)">
      <path fill="currentColor" d="M10.01,1.56l20.44,20.43c0.72,0.68,0.75,1.8,0.07,2.52c-0.7,0.66-1.82,0.64-2.49-0.05
        c-0.01-0.01-0.01-0.02-0.02-0.02L7.56,4.01C6.84,3.32,6.81,2.2,7.49,1.48c0.7-0.66,1.82-0.64,2.49,0.05
        C9.99,1.54,10,1.55,10.01,1.56z"/>
      <path fill="currentColor" d="M7.56,21.99L28,1.56c0.66-0.7,1.78-0.75,2.49-0.1c0.01,0.01,0.02,0.01,0.02,0.02
        C31.19,2.2,31.15,3.32,30.44,4L10.01,24.44c-0.66,0.7-1.78,0.75-2.49,0.1c-0.01-0.01-0.02-0.02-0.03-0.03
        C6.81,23.79,6.84,22.67,7.56,21.99z"/>
    </g>
  `,
});

const filter = new TeSvg({
  path: svg`
    <g transform="translate(-12 -12)">
      <path
        d="M16.32 14.1h16c1.1 0 2 .9 2 2s-.9 2-2 2h-16a2 2 0 110-4z"
        fill="currentColor"
      ></path>
      <path
        d="M16.32 22.1h6c1.1 0 2 .9 2 2s-.9 2-2 2h-6a2 2 0 110-4z"
        fill="currentColor"
      ></path>
      <path
        d="M16.32 30.1c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2a2 2 0 012-2z"
        fill="currentColor"
      ></path>
    </g>
  `,
});

const plus = new TeSvg({
  path: svg`
   <g id="Group_4840" transform="translate(-724 -889)" >
	<path id="Rectangle_1276" class="st0" d="M736,889L736,889c1.1,0,2,0.9,2,2v20c0,1.1-0.9,2-2,2l0,0c-1.1,0-2-0.9-2-2v-20
		C734,889.9,734.9,889,736,889z" fill='#333333'/>
	<path id="Rectangle_1277" class="st0" d="M748,901L748,901c0,1.1-0.9,2-2,2h-20c-1.1,0-2-0.9-2-2l0,0c0-1.1,0.9-2,2-2h20
		C747.1,899,748,899.9,748,901z" fill='#333333'/>
</g>
  `,
});

const minus = new TeSvg({
  path: svg`
    <path
      d="M0 9.6h24v4.8H0V9.6z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill="currentColor"
    ></path>
  `,
});

const search = new TeSvg({
  path: svg`
    <path
      d="M23.72 21.26l-5.94-5.94a.964.964 0 00-1.07-.19C19.9 11.07 19.2 5.19 15.13 2S5.19-.49 2 3.57-.49 13.51 3.57 16.7a9.343 9.343 0 0011.56 0c-.17.36-.09.79.19 1.07l5.94 5.94c.37.37.98.37 1.35 0l1.11-1.11c.37-.36.37-.96 0-1.34zM9.36 15.62c-3.46 0-6.27-2.81-6.27-6.27 0-3.46 2.81-6.27 6.27-6.27 3.46 0 6.27 2.81 6.27 6.27 0 3.47-2.81 6.27-6.27 6.27z"
      fill="currentColor"
    ></path>
  `,
});

const polygon = new TeSvg({
  path: svg`
    <path
      d="M24 6.61V.15h-6.55V2.3H6.55V.15H0v6.46h2.18v10.77H0v6.46h6.55V21.7h10.91v2.15H24v-6.46h-2.18V6.61H24zM2.18 2.3h2.18v2.16H2.18V2.3zm2.18 19.4H2.18v-2.15h2.18v2.15zm13.09-2.16H6.55v-2.15H4.36V6.61h2.18V4.46h10.91v2.15h2.18v10.77h-2.18v2.16zm4.37 2.16h-2.18v-2.15h2.18v2.15zM19.64 4.46V2.3h2.18v2.16h-2.18z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill="currentColor"
    ></path>
  `,
});

const addSubAreaPolygon = new TeSvg({
  path: svg`
    <g>
      <path
        d="M23 14.41v.2l-1.19 1.19v-1.94l.32-.32.87.87zM23 6.93v1.95l-1.19 1.19V8.12L23 6.93zM21.81 13.86v1.94l-6.01 6.01h-1.95l7.96-7.95z"
        fill="currentColor"
      ></path>
      <path
        d="M21.81 8.12v1.95L10.07 21.81H8.13L21.81 8.12zM20.85 2.38l1 1-.74.74a4.47 4.47 0 00-.94-1z"
        fill="currentColor"
      ></path>
      <path
        d="M21.08 4.09l-17 17a4.75 4.75 0 01-1-.95l17.05-17a4.47 4.47 0 01.95.95zM16.15 1.97l-.22.22h-1.94L15.18 1l.97.97z"
        fill="currentColor"
      ></path>
      <path
        d="M15.93 2.19L2.19 15.94v-1.95l11.8-11.8h1.94zM15.8 21.81L14.61 23h-.53l-.71-.71.48-.48h1.95zM10.07 21.81L8.88 23h-.06l-.94-.94.25-.25h1.94zM9.75 2.14l-.05.05H7.76l1.02-1.02.97.97z"
        fill="currentColor"
      ></path>
      <path
        d="M9.7 2.19L2.19 9.7V7.76l5.57-5.57H9.7zM3.35 21.82l-1-1 .72-.72a4.75 4.75 0 001 .95zM2.19 13.99v1.95L1 17.13v-1.95l1.19-1.19zM2.19 7.76V9.7l-.22.22L1 8.95l1.19-1.19z"
        fill="currentColor"
      ></path>
      <path
        d="M2.37 20.85l1 1 .74-.74a4.33 4.33 0 002.41.73h1.61l-.25.25.94.94h.06l1.19-1.19h3.78l-.48.48.71.71h.53l1.19-1.19h1.7a4.31 4.31 0 004.31-4.31V15.8L23 14.61v-.2l-.87-.87-.32.32v-3.79L23 8.88v-2l-1.19 1.24V6.5a4.33 4.33 0 00-.73-2.41l.74-.74-1-1-.71.71a4.34 4.34 0 00-2.64-.9h-1.54l.22-.16-1-1L14 2.19H9.7h.05l-1-1-1 1H6.5A4.31 4.31 0 002.19 6.5v1.26L1 9l1 1 .22-.22V14L1 15.18v1.95l1.19-1.19v1.56a4.25 4.25 0 00.9 2.63zM.5 6.5a6 6 0 016-6h11a6 6 0 016 6v11a6 6 0 01-6 6h-11a6 6 0 01-6-6z"
        fill="currentColor"
      ></path>
    </g>
  `,
});

const editSubAreaPolygon = new TeSvg({
  path: svg`
    <g>
      <path
        d="M6 0h12a6 6 0 016 6v12a6 6 0 01-6 6H6a6 6 0 01-6-6V6a6 6 0 016-6z"
        fill="none"
      ></path>
      <path
        d="M6 1.5A4.51 4.51 0 001.5 6v12A4.51 4.51 0 006 22.5h12a4.51 4.51 0 004.5-4.5V6A4.51 4.51 0 0018 1.5H6M6 0h12a6 6 0 016 6v12a6 6 0 01-6 6H6a6 6 0 01-6-6V6a6 6 0 016-6z"
        fill="currentColor"
      ></path>
    </g>
    <path
      d="M4.5 16.37v3.13h3.12l9.22-9.22-3.13-3.12zm14.76-8.5a.83.83 0 000-1.17l-2-1.95a.83.83 0 00-1.18 0l-1.47 1.52 3.12 3.12 1.53-1.53z"
      fillRule="evenodd"
      fill="currentColor"
    ></path>
  `,
});

const cloudUp = new TeSvg({
  path: svg`
    <path
      fill="currentColor"
      d="M19.35,9.8C18.67,6.23,15.64,3.55,12,3.55c-2.89,0-5.4,1.7-6.65,4.18C2.34,8.06,0,10.7,0,13.9
    c0,3.42,2.69,6.21,6,6.21h13c2.76,0,5-2.32,5-5.17C24,12.2,21.95,9.99,19.35,9.8L19.35,9.8z M13.75,12.61v4.14h-4v-4.14h-3l5-5.17
    l5,5.17H13.75L13.75,12.61z"
    ></path>
  `,
});

const upload = new TeSvg({
  path: svg`
    <path
      d="M18.73 16.84h-4.29v1.52h4.29a5.284 5.284 0 005.27-5.3 5.309 5.309 0 00-3.23-4.86c.03-.24.05-.49.05-.73-.01-3.24-2.63-5.86-5.86-5.86-1.71 0-3.34.74-4.46 2.02-.7-.45-1.52-.7-2.35-.7-2.34 0-4.24 1.89-4.25 4.23 0 .27.03.54.08.81a5.284 5.284 0 001.3 10.4h4.29v-1.52H5.28a3.76 3.76 0 01-3.76-3.75 3.877 3.877 0 014.71-3.77c-.55-.59-.84-1.36-.81-2.16.01-1.5 1.22-2.72 2.73-2.73 1.16.02 2.19.72 2.65 1.78a4.32 4.32 0 014.16-3.09c2.4 0 4.34 1.94 4.34 4.34.03.63-.08 1.27-.3 1.86a3.75 3.75 0 013.48 3.76 3.764 3.764 0 01-3.75 3.75zM8.36 14.3l1.07 1.07 1.81-1.8v8.82h1.52v-8.82l1.81 1.8 1.07-1.07L12 10.65 8.36 14.3z"
      fill="currentColor"
    ></path>
  `,
});

const uploadThin = new TeSvg({
  path: svg`
    <g transform="translate(-213 -302.3)">
      <path
        fill="currentColor"
        d="M222.57 320.04h-4.24a4.076 4.076 0 01-4.06-4.09 4.1 4.1 0 014.4-4.06c-.34-.53-.53-1.14-.54-1.78a3.06 3.06 0 015.57-1.73c.8-1.6 2.43-2.6 4.21-2.6a4.667 4.667 0 014.41 6.15c2.22.39 3.71 2.5 3.32 4.73a4.075 4.075 0 01-4 3.38h-4.24v.78h4.24c2.69-.01 4.86-2.2 4.85-4.88a4.85 4.85 0 00-3.24-4.56c.06-.31.09-.63.09-.95 0-3-2.43-5.43-5.43-5.43-1.69 0-3.29.78-4.33 2.12a3.98 3.98 0 00-2.39-.83c-2.11 0-3.83 1.71-3.84 3.82 0 .36.06.72.17 1.07a4.866 4.866 0 00-4.02 4.77 4.857 4.857 0 004.84 4.87h4.24v-.78z"
      ></path>
      <path
        fill="currentColor"
        d="M221.51 317.42l.54.54 2.41-2.39v9.58h.78v-9.58l2.41 2.39.54-.54-3.34-3.35-3.34 3.35z"
      ></path>
    </g>
  `,
});

const uploadError = new TeSvg({
  path: svg`
    <path
      fill="currentColor"
      d="M19.59 7c.06-.29.08-.59.09-.89 0-2.82-2.29-5.1-5.11-5.11-1.59 0-3.1.74-4.08 2a3.7 3.7 0 00-2.25-.78 3.61 3.61 0 00-3.61 3.59c0 .34.06.68.16 1-2.18.39-3.78 2.28-3.78 4.49a4.569 4.569 0 004.55 4.59h3.99v-.73H5.56a3.832 3.832 0 01-3.82-3.85 3.847 3.847 0 014.13-3.82c-.32-.5-.5-1.08-.51-1.67a2.874 2.874 0 015.23-1.63c.75-1.5 2.28-2.45 3.96-2.45 2.41.01 4.37 1.96 4.37 4.37 0 .48-.08.96-.23 1.42a3.838 3.838 0 01-.63 7.62h-3.99v.73h3.99a4.577 4.577 0 004.56-4.59A4.55 4.55 0 0019.59 7zM14.01 18.35a.326.326 0 00-.45 0l-1.81 1.81-1.81-1.81a.333.333 0 00-.47.02c-.12.13-.12.32 0 .45l1.81 1.81-1.8 1.8c-.13.12-.14.33-.02.47.07.06.15.1.24.1.08 0 .17-.03.24-.1l1.81-1.81 1.81 1.81c.06.06.15.1.24.09.09 0 .17-.04.23-.11.12-.13.12-.32 0-.45l-1.81-1.81 1.81-1.81a.32.32 0 00-.02-.46z"
    ></path>
  `,
});

const checkmark = new TeSvg({
  path: svg`
    <path
      d="M8.6,20.6L0,12.3L2.4,10l6.2,5.9l13-12.5L24,5.8L8.6,20.6z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill="currentColor"
    ></path>
  `,
});

const checkmarkcircle = new TeSvg({
  path: svg`
    <g transform="translate(-1663 164)">
      <path
        d="M1675.07-140.13c-6.59,0-11.93-5.34-11.93-11.93c0-6.59,5.34-11.93,11.93-11.93
        c6.59,0,11.93,5.34,11.93,11.93C1687-145.48,1681.66-140.13,1675.07-140.13z M1675.07-143.8c4.56,0,8.26-3.7,8.26-8.26
        c0-4.56-3.7-8.26-8.26-8.26c-4.56,0-8.26,3.7-8.26,8.26C1666.8-147.5,1670.5-143.8,1675.07-143.8L1675.07-143.8"
        fillRule="evenodd"
        clipRule="evenodd"
        fill="currentColor"
      ></path>
      <path
        d="M1673.28-147.09l-5.54-5.5l1.56-1.55l3.98,3.94l8.41-8.35l1.56,1.56L1673.28-147.09z"
        fillRule="evenodd"
        clipRule="evenodd"
        fill="currentColor"
      ></path>
    </g>
  `,
});

const share = new TeSvg({
  path: svg`
    <path
      d="M19.25 16.96c-.88 0-1.72.33-2.37.93l-8.61-5c.15-.55.15-1.13 0-1.69l8.52-4.95a3.603 3.603 0 004.88-5.3 3.603 3.603 0 00-5.09.21c-.61.67-.95 1.54-.95 2.45.01.28.04.57.11.84L7.22 9.41c-1.46-1.36-3.75-1.29-5.11.17s-1.29 3.74.17 5.11c1.39 1.3 3.55 1.3 4.94 0l8.6 5.01c-.06.26-.1.52-.1.78-.01 1.95 1.57 3.53 3.52 3.54s3.53-1.57 3.54-3.52c0-1.95-1.58-3.53-3.53-3.54"
      fillRule="evenodd"
      clipRule="evenodd"
      fill="currentColor"
    ></path>
  `,
});

const expand = new TeSvg({
  path: svg`
    <path
      d="M23.44 8.19L20.51 5.4l-3.66 3.5-1.81-1.72 3.69-3.48L15.79.91h7.66v7.28zM.47 15.47l2.94 2.79 3.66-3.5 1.81 1.72-3.69 3.48 2.94 2.79H.47v-7.28z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill="currentColor"
    ></path>
  `,
});

const collapse = new TeSvg({
  path: svg`
    <g>
      <path
        d="M1.34 15.13 l 2.88 2.88 -3.62 3.6 1.78 1.78 3.6-3.62 2.88 2.88 v-7.52 H 1.34 z"
        fill="currentColor"
        className="bottomLeft"
      ></path>
      <path
        d="M1.34 15.13 m21.32-6.26 l -2.88 -2.88 3.62 -3.6 L 21.62 0.6 l -3.6 3.62 -2.88 -2.88 v 7.52 h 7.52 z"
        fill="currentColor"
        className="topRight"
      ></path>
    </g>
  `,
});

const bell = new TeSvg({
  path: svg`
    <path
      d="M12 24c1.32 0 2.4-1.08 2.4-2.4H9.6c0 1.32 1.08 2.4 2.4 2.4zm7.8-7.2v-6.6c0-3.61-2.48-6.75-6-7.59V1.8C13.8.81 12.99 0 12 0s-1.8.81-1.8 1.8v.81c-3.52.83-6 3.97-6 7.59v6.6l-2.4 2.4v1.2h20.4v-1.2l-2.4-2.4z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill="currentColor"
    ></path>
  `,
});

const mapPin = new TeSvg({
  path: svg`
    <path
      d="M20.06 6c-.07-.3-.3-.68-.37-.98A8.408 8.408 0 0011.89 0a8.065 8.065 0 00-8.25 7.43v1.65c.3 2.4 2.23 4.95 3.64 7.35 1.56 2.55 3.12 5.1 4.68 7.58.97-1.65 1.93-3.3 2.9-4.88.22-.45.59-.98.82-1.35.15-.3.52-.6.67-.9 1.56-2.77 4.01-5.55 4.01-8.32v-1.2c-.04-.47-.14-.92-.3-1.36M12 11.22c-1.81.02-3.29-1.44-3.31-3.25s1.44-3.29 3.25-3.31a3.282 3.282 0 013.31 3.25v.03A3.27 3.27 0 0112 11.22"
      fill="currentColor"
    ></path>
  `,
});

const schedule = new TeSvg({
  path: svg`
    <path
      d="M19.56 4.58c-.46.52-1.25.6-1.81.17a9.39 9.39 0 00-12.29.69c-3.62 3.57-3.66 9.4-.09 13.02l.09.09c3.66 3.63 9.57 3.63 13.23 0a8.646 8.646 0 002.67-5.36c.07-.68.64-1.19 1.31-1.19a1.332 1.332 0 011.31 1.55c-.39 2.59-1.59 5-3.42 6.88-4.72 4.66-12.31 4.66-17.03 0-4.66-4.59-4.72-12.09-.13-16.75l.11-.11a12.03 12.03 0 0115.9-.91c.57.46.66 1.29.2 1.86-.01.02-.03.03-.04.05l-.01.01zm-6.84 1.93v5.69l4.69 2.78-.96 1.62-5.73-3.4V6.5l2 .01z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill="currentColor"
    ></path>
  `,
});

const map = new TeSvg({
  path: svg`
    <path
      d="M23.03.31l-.21.04-7.03 2.72L7.9.31.48 2.81C.2 2.9 0 3.15 0 3.44v19.9c0 .36.29.66.65.66h.01l.21-.04 7.03-2.72L15.8 24l7.42-2.5c.28-.08.47-.34.47-.63V.97c0-.36-.28-.65-.64-.66h-.02zm-7.24 21.06l-7.9-2.78V2.94l7.9 2.78v15.65z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill="currentColor"
    ></path>
  `,
});

const arrowRight = new TeSvg({
  path: svg`
    <path
      d="M0 10.71h18.89L14.12 6.1 16 4.29 24 12l-8 7.71-1.88-1.81 4.77-4.62H0v-2.57z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill="currentColor"
    ></path>
  `,
});

const arrowLeft = new TeSvg({
  path: arrowRight.path,
  style: 'transform: rotate(180deg);',
});

const arrowUpCircle = new TeSvg({
  path: svg`
    <path
      data-name="Icon awesome-arrow-alt-circle-up"
      d="M0 12a12 12 0 1112 12A12 12 0 010 12zm14.12 5.61V12h3.43a.58.58 0 00.45-1l-5.59-5.52a.58.58 0 00-.82 0L6 11a.57.57 0 000 .82.57.57 0 00.41.17h3.46v5.61a.58.58 0 00.58.58h3.1a.57.57 0 00.57-.57z"
      fill="currentColor"
    ></path>
  `,
});

const triangleLeft = new TeSvg({
  path: svg`
    <path
      d="M19.2 0L4.8 12l14.4 12V0z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill="currentColor"
    ></path>
  `,
});

const triangleRight = new TeSvg({
  path: triangleLeft.path,
  style: 'transform: rotate(180deg);',
});

const triangleUp = new TeSvg({
  path: triangleLeft.path,
  style: 'transform: rotate(90deg);',
});

const triangleDown = new TeSvg({
  path: triangleLeft.path,
  style: 'transform: rotate(-90deg);',
});

const user = new TeSvg({
  path: svg`
    <path
      d="M11.33 12c-1.6.03-3.13-.61-4.24-1.76A5.776 5.776 0 015.33 6c-.02-1.6.61-3.13 1.76-4.24A5.754 5.754 0 0111.33 0c1.6-.03 3.13.61 4.24 1.76A5.738 5.738 0 0117.33 6c.03 1.6-.61 3.13-1.75 4.24A5.76 5.76 0 0111.33 12zm.67 2.67c1.65.02 3.29.24 4.89.66 1.75.42 3.4 1.15 4.89 2.15 1.27.67 2.11 1.95 2.22 3.39V24H0v-3.14c.1-1.44.94-2.72 2.22-3.39 1.49-1 3.15-1.73 4.89-2.15 1.6-.41 3.24-.63 4.89-.65z"
      fill="currentColor"
    ></path>
  `,
});

const userAdd = new TeSvg({
  path: svg`
    <path
      d="M14.56 3.57c2.38-.04 4.35 1.85 4.39 4.23.04 2.38-1.85 4.35-4.23 4.39-2.38.04-4.35-1.85-4.39-4.23v-.08a4.274 4.274 0 014.23-4.31zM24 20.43H5.19V19c0-3.19 6.27-4.95 9.4-4.95S24 15.8 24 19v1.43zM5.31 9.89V6.73H3.18v3.16H0V12h3.18v3.17H5.3V12h3.18V9.89H5.31z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill="currentColor"
    ></path>
  `,
});

const pdf = new TeSvg({
  path: svg`
    <g>
      <path
        fill="transparent"
        d="M3.39 23.63V.39h12.15l5.78 5.78v17.46H3.39z"
      ></path>
      <g>
        <path
          fill="currentColor"
          d="M15.4.72l5.59 5.59V23.3H3.72V.72H15.4m.28-.66H3.06v23.91h18.59V6.03L15.68.06z"
        ></path>
      </g>
    </g>
    <g transform="translate(17.842)">
      <path fill="transparent" d="M-2.5 6.37V.39h.19l5.78 5.78v.19l-5.97.01z" ></path>
      <g>
        <path
          fill="currentColor"
          d="M-2.17.99l5.04 5.04h-5.04V.99m0-.93h-.66V6.7h6.64v-.67L-2.17.06z"
        ></path>
      </g>
    </g>
    <path
      fill="currentColor"
      d="M7.8 14.85V13.7h.65c.09 0 .19.01.28.02.08.01.16.04.24.08.07.04.13.1.16.17.04.09.07.19.06.29 0 .1-.02.2-.06.29-.04.07-.09.13-.16.17a.62.62 0 01-.24.08c-.09.01-.19.02-.28.02H7.8zm-.84-1.8v3.83h.84v-1.37h.88c.21.01.42-.03.61-.1.16-.06.3-.16.41-.28.1-.11.18-.25.23-.39.1-.3.1-.61 0-.91a1.09 1.09 0 00-.64-.67c-.19-.07-.4-.11-.61-.1H6.96zm4.74 3.12v-2.41h.6c.18-.01.36.02.52.09.13.05.25.14.34.25.09.12.15.26.18.4.04.17.06.35.06.52 0 .18-.02.36-.08.54-.05.13-.12.25-.21.36a.79.79 0 01-.31.2c-.11.04-.23.06-.35.06l-.75-.01zm-.84-3.12v3.83h1.65c.26.01.52-.04.76-.15.21-.09.39-.23.54-.4.15-.18.26-.39.32-.61.07-.25.11-.51.11-.77 0-.28-.04-.56-.13-.83-.08-.22-.2-.42-.36-.59-.16-.16-.34-.28-.55-.35-.22-.08-.45-.12-.69-.12l-1.65-.01zm4.29 0v3.83h.84V15.3h1.6v-.65h-1.6v-.88h1.85v-.71h-2.69z"
    ></path>
  `,
});

const tiff = new TeSvg({
  path: svg`
    <g transform="translate(-2.246)">
      <g transform="translate(2.246)">
        <path fill="transparent" d="M3.27 23.49V.5h12.02l5.72 5.72v17.27H3.27z" ></path>
        <g>
          <path
            fill="currentColor"
            d="M15.16.83l5.53 5.53v16.81H3.6V.83h11.56m.27-.66H2.95v23.65h18.39V6.08L15.43.17z"
          ></path>
        </g>
      </g>
      <g transform="translate(20.088)">
        <path fill="transparent" d="M-2.74 6.41V.5h.19l5.72 5.72v.19h-5.91z" ></path>
        <g>
          <path
            fill="currentColor"
            d="M-2.41 1.1l4.98 4.98h-4.98V1.1m0-.93h-.66v6.57H3.5v-.66L-2.41.17z"
          ></path>
        </g>
      </g>
      <path
        fill="currentColor"
        d="M9.49 13.73v3.09h.83v-3.09h1.14v-.7h-3.1v.7h1.13zm2.71-.7v3.79h.83v-3.79h-.83zm1.89 0v3.79h.83v-1.56h1.59v-.66h-1.59v-.87h1.83v-.7h-2.66zm3.46 0v3.79h.83v-1.56h1.59v-.66h-1.58v-.87h1.83v-.7h-2.67z"
      ></path>
    </g>
  `,
});

const del = new TeSvg({
  path: svg`
    <path
      d="M3.84 21.33A2.7 2.7 0 006.56 24h10.88a2.7 2.7 0 002.72-2.67v-16H3.84v16zm17.68-20h-4.76L15.4 0H8.6L7.24 1.33H2.48V4h19.03l.01-2.67z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill="currentColor"
    ></path>
  `,
});

const moreItems = new TeSvg({
  path: svg`
    <g id="icon" transform="translate(-4.5 -15.328)">
      <path
        fill="currentColor"
        d="M16.5,24.3c-1.7,0-3,1.3-3,3c0,1.7,1.3,3,3,3s3-1.3,3-3l0,0C19.5,25.7,18.2,24.3,16.5,24.3z"
      ></path>
      <path
        fill="currentColor"
        d="M7.5,24.3c-1.7,0-3,1.3-3,3c0,1.7,1.3,3,3,3s3-1.3,3-3c0,0,0,0,0,0C10.5,25.7,9.2,24.3,7.5,24.3
      z"
      ></path>
      <path
        fill="currentColor"
        d="M25.5,24.3c-1.7,0-3,1.3-3,3c0,1.7,1.3,3,3,3c1.7,0,3-1.3,3-3c0,0,0,0,0,0
      C28.5,25.7,27.2,24.3,25.5,24.3z"
      ></path>
    </g>
  `,
});

const moreItemsVertical = new TeSvg({
  path: moreItems.path,
  style: 'transform: rotate(90deg);',
});

const edit = new TeSvg({
  path: svg`
    <path
      d="M.17 24v-4.97l14.4-14.67 4.88 4.97L5.05 24H.17zM15.96 2.94L18.34.51c.5-.51 1.31-.51 1.81-.02l.02.02 3.05 3.11c.51.52.51 1.35 0 1.87l-2.39 2.43-4.87-4.98z"
      fill="currentColor"
    ></path>
  `,
});

const editPolygon = new TeSvg({
  path: svg`
    <path
      d="M2.18 2.18h2.18v2.18H2.18zM2.18 19.64h2.18v2.18H2.18zM6.55 6.54H4.37l-.01 10.92h2.18v2.18h10.91v-2.18h2.18l-4.98-4.99L12.12 15H9v-3.12l2.53-2.53-4.98-4.98zM19.64 19.64h2.18v2.18h-2.18z"
      fill="none"
    ></path>
    <path
      d="M14.65 12.47l6.68-6.68-3.12-3.13-6.68 6.69L9 11.88V15h3.12l2.53-2.53 4.98 4.98h-2.18v2.18H6.54v-2.18H4.36V6.54h2.18V4.37l4.98 4.98-4.97-4.99V0H0v6.55h2.18v10.91H0V24h6.55v-2.18h10.91V24H24v-6.54h-4.36l-4.99-4.99zM2.18 2.18h2.18v2.18H2.18V2.18zm2.18 19.64H2.18v-2.18h2.18v2.18zm17.46 0h-2.18v-2.18h2.18v2.18zM23.76 3.37c.32-.32.32-.85 0-1.17L21.81.25a.845.845 0 00-1.18 0l-1.52 1.53 3.12 3.12 1.53-1.53z"
      fill="currentColor"
    ></path>
  `,
});

const layers = new TeSvg({
  path: svg`
    <path
      d="M11.99 20.82L2.5 13.6.41 15.19 12 24l11.59-8.81-2.1-1.6-9.5 7.23zm.01-3.2l9.48-7.21 2.11-1.6L12 0 .41 8.81l2.1 1.6L12 17.62z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill="currentColor"
    ></path>
  `,
});

const milestone = new TeSvg({
  path: svg`
    <g>
      <path
        fill="currentColor"
        d="M18.7,6.3c0.8,0.5,0.9,1.3,0.4,2.1c-0.1,0.1-0.3,0.3-0.4,0.4L11,13.7c-0.8,0.4-1.7,0.3-2.1-0.4
      c-0.2-0.3-0.3-0.5-0.3-0.8V2.7c0-0.9,0.8-1.5,1.5-1.5c0.3,0,0.6,0.1,0.8,0.3L18.7,6.3z"
      ></path>
      <path
        fill="currentColor"
        d="M4.1,0L4.1,0C5,0,5.6,0.6,5.6,1.5v21C5.6,23.4,5,24,4.1,24l0,0c-0.9,0-1.5-0.6-1.5-1.5v-21
      C2.6,0.6,3.4,0,4.1,0z"
      ></path>
    </g>
  `,
});

const grid = new TeSvg({
  path: svg`
    <path
      d="M.96 0h4.8c.53-.02.97.4.99.93v4.83c.02.53-.4.97-.93.99H.96C.43 6.75 0 6.32 0 5.8V.96C0 .43.43 0 .96 0zm7.67.96v4.8c-.02.53.4.97.93.99h4.83c.53 0 .96-.43.96-.96V.96a.96.96 0 00-.96-.96h-4.8a.96.96 0 00-.96.96zm8.62 0v4.8c-.02.53.4.97.93.99h4.85c.53 0 .97-.42.97-.95V.96a.96.96 0 00-.96-.96H18.22a.946.946 0 00-.97.94v.02zM0 9.59v4.8c0 .53.43.96.96.96h4.8c.53.02.97-.4.99-.93V9.59a.96.96 0 00-.96-.96H.96a.96.96 0 00-.96.96zm8.63 0v4.8c0 .53.43.96.96.96h4.8c.53 0 .96-.43.96-.96v-4.8a.96.96 0 00-.96-.96h-4.8a.96.96 0 00-.96.96zm8.63 0v4.8c0 .53.43.96.96.96h4.8c.53.01.97-.42.97-.95V9.59a.96.96 0 00-.96-.96h-4.8a.96.96 0 00-.99.93v.03h.02zM0 18.23v4.8c0 .53.42.97.95.97h4.81c.53.02.97-.4.99-.93v-4.85a.96.96 0 00-.94-.98H.96c-.53.01-.96.44-.96.97v.02zm8.63 0v4.8c0 .53.42.96.95.97h4.81c.53 0 .96-.43.96-.96v-4.8a.96.96 0 00-.93-.99H9.59a.96.96 0 00-.96.96v.02zm8.63 0v4.8c0 .53.42.96.95.97H23.03c.53.01.96-.42.97-.95v-4.83a.96.96 0 00-.94-.98h-4.83a.96.96 0 00-.98.94v.04l.01.01z"
      fill="currentColor"
    ></path>
  `,
});

const sitesLandscape = new TeSvg({
  path: svg`
    <path
      d="M1.7,4.3h20.6C23.2,4.3,24,5.1,24,6v12c0,0.9-0.8,1.7-1.7,1.7H1.7C0.8,19.7,0,18.9,0,18V6 C0,5.1,0.8,4.3,1.7,4.3z"
      fill="currentColor"
    ></path>
  `,
});

const sitesGrid = new TeSvg({
  path: svg`
    <g transform="translate(0.286 -2)">
      <path
        id="Rectangle_883"
        d="M0.6,6.3h5.1c0.5,0,0.9,0.4,0.9,0.9v5.1c0,0.5-0.4,0.9-0.9,0.9H0.6c-0.5,0-0.9-0.4-0.9-0.9 V7.1C-0.3,6.7,0.1,6.3,0.6,6.3z"
        fill="currentColor"
      ></path>
      <path
        id="Rectangle_884"
        d="M9.1,6.3h5.1c0.5,0,0.9,0.4,0.9,0.9v5.1c0,0.5-0.4,0.9-0.9,0.9H9.1c-0.5,0-0.9-0.4-0.9-0.9 V7.1C8.3,6.7,8.7,6.3,9.1,6.3z"
        fill="currentColor"
      ></path>
      <path
        id="Rectangle_888"
        d="M17.7,6.3h5.1c0.5,0,0.9,0.4,0.9,0.9v5.1c0,0.5-0.4,0.9-0.9,0.9h-5.1 c-0.5,0-0.9-0.4-0.9-0.9V7.1C16.9,6.7,17.2,6.3,17.7,6.3z"
        fill="currentColor"
      ></path>
      <path
        id="Rectangle_885"
        d="M0.6,14.9h5.1c0.5,0,0.9,0.4,0.9,0.9v5.1c0,0.5-0.4,0.9-0.9,0.9H0.6 c-0.5,0-0.9-0.4-0.9-0.9v-5.1C-0.3,15.2,0.1,14.9,0.6,14.9z"
        fill="currentColor"
      ></path>
      <path
        id="Rectangle_886"
        d="M9.1,14.9h5.1c0.5,0,0.9,0.4,0.9,0.9v5.1c0,0.5-0.4,0.9-0.9,0.9H9.1 c-0.5,0-0.9-0.4-0.9-0.9v-5.1C8.3,15.2,8.7,14.9,9.1,14.9z"
        fill="currentColor"
      ></path>
      <path
        id="Rectangle_889"
        d="M17.7,14.9h5.1c0.5,0,0.9,0.4,0.9,0.9v5.1c0,0.5-0.4,0.9-0.9,0.9h-5.1 c-0.5,0-0.9-0.4-0.9-0.9v-5.1C16.9,15.2,17.2,14.9,17.7,14.9z"
        fill="currentColor"
      ></path>
    </g>
  `,
});

const point = new TeSvg({
  path: svg`
    <path
      d="M12 0C5.37 0 0 5.37 0 12s5.37 12 12 12 12-5.37 12-12C23.99 5.38 18.62.01 12 0zm0 21.6c-5.3 0-9.6-4.3-9.6-9.6S6.7 2.4 12 2.4s9.6 4.3 9.6 9.6c-.01 5.3-4.3 9.59-9.6 9.6zm1.8-9.6c0 .99-.81 1.8-1.8 1.8s-1.8-.81-1.8-1.8.81-1.8 1.8-1.8 1.8.81 1.8 1.8z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill="currentColor"
    ></path>
  `,
});

const pentagon = new TeSvg({
  path: svg`
    <path
      d="M12 .86l12 8.51-4.58 13.77H4.58L0 9.37 12 .86zm0 3.9L3.63 10.7l3.2 9.61h10.34l3.2-9.61L12 4.76z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill="currentColor"
    ></path>
  `,
});

const menu = new TeSvg({
  path: svg`
   <g transform="translate(-4.5 -10.125)">
	<path id="Path_389" class="st0" d="M27.5,17.38h-22c-0.59-0.04-1.03-0.54-1-1.12l0,0c-0.03-0.59,0.41-1.09,1-1.12h22
		c0.59,0.04,1.03,0.54,1,1.12l0,0C28.53,16.84,28.08,17.34,27.5,17.38z" fill="currentColor"/>
	<path id="Path_390" class="st0" d="M27.5,23.25h-22c-0.59-0.04-1.03-0.54-1-1.12l0,0c-0.03-0.59,0.41-1.09,1-1.12h22
		c0.59,0.04,1.03,0.54,1,1.12l0,0C28.53,22.71,28.08,23.21,27.5,23.25z" fill="currentColor"/>
	<path id="Path_391" class="st0" d="M27.5,29.12h-22c-0.59-0.04-1.03-0.54-1-1.12l0,0c-0.03-0.59,0.41-1.09,1-1.12h22
		c0.59,0.04,1.03,0.54,1,1.12l0,0C28.53,28.58,28.08,29.09,27.5,29.12z" fill="currentColor"/>
</g>
  `,
});

const dragRight = new TeSvg({
  path: svg`
    <g>
      <path
        fill="currentColor"
        d="M18.6,10.7c0.7,0.4,0.9,1.4,0.5,2.1c-0.1,0.2-0.3,0.4-0.5,0.5L11,18.1
      c-0.7,0.4-1.6,0.2-2.1-0.5c-0.2-0.2-0.2-0.5-0.2-0.8V7.2c0-0.8,0.7-1.5,1.5-1.5c0.3,0,0.6,0.1,0.8,0.2L18.6,10.7z"
      ></path>
      <path
        fill="currentColor"
        d="M4.2,0L4.2,0C5,0,5.7,0.7,5.7,1.5v21C5.7,23.3,5,24,4.2,24l0,0c-0.8,0-1.5-0.7-1.5-1.5
      v-21C2.7,0.7,3.3,0,4.2,0z"
      ></path>
    </g>
  `,
});

const scheduleAdd = new TeSvg({
  path: svg`
    <g>
      <path
        d="M19.57 4.56c-.46.52-1.25.59-1.81.16a9.39 9.39 0 00-12.29.69 9.205 9.205 0 00-.1 13.01l.1.1c3.66 3.63 9.57 3.63 13.23 0a8.62 8.62 0 002.67-5.36c.07-.67.64-1.18 1.31-1.18a1.332 1.332 0 011.31 1.55c-.39 2.59-1.59 5-3.41 6.88-4.72 4.66-12.31 4.66-17.03 0-4.66-4.59-4.72-12.08-.13-16.74l.11-.11C7.84-.71 14.66-1.1 19.44 2.65c.57.46.66 1.29.2 1.86-.01.02-.03.03-.04.05h-.03z"
        fillRule="evenodd"
        clipRule="evenodd"
        fill="currentColor"
      ></path>
      <path
        d="M12.68 11.3V6.97h-1.34v4.33H7.03v1.34h4.31v4.33h1.34v-4.33h4.31V11.3h-4.31z"
        strokeWidth=0.5
        fill="currentColor"
      ></path>
    </g>
  `,
});

const scheduleList = new TeSvg({
  path: svg`
    <g>
      <path
        fill="currentColor"
        d="M14,7.1a.94.94,0,0,1-1.29.12,6.69,6.69,0,0,0-8.76.49A6.55,6.55,0,0,0,3.83,17a.46.46,0,0,0,.07.07,6.69,6.69,0,0,0,9.43,0,6.13,6.13,0,0,0,1.91-3.83.94.94,0,0,1,.93-.84h0a1,1,0,0,1,.95,1s0,.09,0,.14a9,9,0,0,1-2.44,4.91,8.66,8.66,0,0,1-12.15,0A8.44,8.44,0,0,1,2.43,6.46l.07-.08a8.58,8.58,0,0,1,11.35-.65A1,1,0,0,1,14,7.06l0,0ZM9.07,8.47v4.06l3.35,2-.69,1.15L7.64,13.25V8.47Z"
      ></path>
      <path fill="currentColor" d="M20.27,6.5h-4.9V7.92H24V6.5Z" ></path>
      <path fill="currentColor" d="M20.27,3.64h-4.9V5.07H24V3.64Z" ></path>
      <path fill="currentColor" d="M20.27,9.35h-4.9v1.43H24V9.35Z" ></path>
    </g>
  `,
});

const scheduleStack = new TeSvg({
  path: svg`
    <g transform="translate(-1703 -976.306)">
      <g transform="translate(1703 976.306)">
        <path
          fill="none"
          d="M1.92,3.29h16.32c1.06,0,1.92,0.86,1.92,1.92v9.6c0,1.06-0.86,1.92-1.92,1.92H1.92
        C0.86,16.73,0,15.87,0,14.81v-9.6C0,4.15,0.86,3.29,1.92,3.29z"
        ></path>
        <path
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
          d="M1.92,4.01h16.32c0.66,0,1.2,0.54,1.2,1.2v9.6c0,0.66-0.54,1.2-1.2,1.2H1.92c-0.66,0-1.2-0.54-1.2-1.2v-9.6
        C0.72,4.55,1.26,4.01,1.92,4.01z"
        ></path>
      </g>
      <g transform="translate(1707 980.306)">
        <path
          fill="currentColor"
          d="M1.76,3.13h16.32c1.06,0,1.92,0.86,1.92,1.92v9.6c0,1.06-0.86,1.92-1.92,1.92H1.76
        c-1.06,0-1.92-0.86-1.92-1.92v-9.6C-0.16,3.99,0.7,3.13,1.76,3.13z"
        ></path>
        <path
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
          d="M1.76,3.85h16.32c0.66,0,1.2,0.54,1.2,1.2v9.6c0,0.66-0.54,1.2-1.2,1.2H1.76c-0.66,0-1.2-0.54-1.2-1.2v-9.6
        C0.56,4.39,1.1,3.85,1.76,3.85z"
        ></path>
      </g>
    </g>
  `,
});

const list = new TeSvg({
  path: svg`
    <g id="list" transform="translate(-4.5 -7.313)">
      <path
        fill="currentColor"
        stroke="currentColor"
        d="M8,19.3c0,1-0.8,1.7-1.7,1.7c-1,0-1.7-0.8-1.7-1.7s0.8-1.7,1.7-1.7h0C7.2,17.6,8,18.3,8,19.3z"
      ></path>
      <path
        fill="currentColor"
        stroke="currentColor"
        d="M8,11.6c0,1-0.8,1.8-1.7,1.8s-1.8-0.8-1.8-1.7c0-1,0.8-1.8,1.7-1.8C7.2,9.8,8,10.6,8,11.6
      L8,11.6z"
      ></path>
      <path
        fill="currentColor"
        stroke="currentColor"
        d="M8,27.1c0,1-0.8,1.7-1.7,1.7S4.5,28,4.5,27.1c0-1,0.8-1.7,1.7-1.7C7.2,25.3,8,26.1,8,27.1
      L8,27.1z"
      ></path>
      <path
        fill="currentColor"
        stroke="currentColor"
        d="M27.5,18.3h-15c-0.6,0-1,0.4-1,1s0.4,1,1,1c0,0,0,0,0,0h15c0.6,0,1-0.4,1-1
      C28.5,18.8,28.1,18.3,27.5,18.3C27.5,18.3,27.5,18.3,27.5,18.3z"
      ></path>
      <path
        fill="currentColor"
        stroke="currentColor"
        d="M27.5,26.1h-15c-0.6,0-1,0.4-1,1c0,0.6,0.4,1,1,1l0,0h15c0.6,0,1-0.4,1-1
      C28.5,26.5,28.1,26.1,27.5,26.1z"
      ></path>
      <path
        fill="currentColor"
        stroke="currentColor"
        d="M12.5,12.6h15c0.6,0,1-0.4,1-1c0-0.6-0.4-1-1-1h-15c-0.6,0-1,0.4-1,1
      C11.5,12.1,11.9,12.6,12.5,12.6L12.5,12.6z"
      ></path>
    </g>
  `,
});

const resize = new TeSvg({
  path: svg`
    <g>
      <polygon fill="currentColor" points="24,12 15.27,16.13 15.27,7.87" ></polygon>
      <polygon fill="currentColor" points="8.72,7.87 8.72,16.13 0,12" ></polygon>
    </g>
  `,
});

const link = new TeSvg({
  path: svg`
    <path
      fill="currentColor"
      d="M7.67,16.66c-1-0.97-1.03-2.57-0.06-3.57l2.26-2.26L8.76,9.72L6.5,11.98
    c-1.57,1.67-1.48,4.29,0.18,5.85c1.59,1.5,4.08,1.5,5.67,0l2.26-2.26l-1.11-1.11l-2.26,2.26C10.23,17.69,8.63,17.66,7.67,16.66
    L7.67,16.66z M10.57,14.93l4.53-4.53l-1.17-1.17L9.4,13.76L10.57,14.93z M12.15,6.33L9.89,8.59L11,9.7l2.26-2.26
    c1.05-0.95,2.67-0.87,3.63,0.18c0.89,0.98,0.89,2.47,0,3.45l-2.26,2.26l1.11,1.11L18,12.18c1.54-1.69,1.43-4.31-0.26-5.85
    C16.16,4.88,13.73,4.88,12.15,6.33z"
    ></path>
  `,
});

const contacts = new TeSvg({
  path: svg`
    <path
      d="M12.21 3.12c2.54-.05 4.64 1.98 4.69 4.52.05 2.54-1.98 4.64-4.52 4.69s-4.64-1.98-4.69-4.52v-.08c-.03-2.53 2-4.59 4.52-4.61zm10.08 18.02H2.19V19.6c0-3.41 6.7-5.29 10.05-5.29s10.05 1.88 10.05 5.29v1.54z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill="currentColor"
    ></path>
  `,
});

const image = new TeSvg({
  path: svg`
    <path
      fill="currentColor"
      d="M29,27a2.006,2.006,0,0,1-2,2H13a2.006,2.006,0,0,1-2-2V13a2.006,2.006,0,0,1,2-2H27a2.006,2.006,0,0,1,2,2ZM16.685,21.466,13.1,26.423H27.426l-4.6-6.61-3.58,4.968Z"
      transform="translate(-8 -8)"
    ></path>
  `,
});

const siteContacts = new TeSvg({
  path: svg`
    <g transform="translate(-.26 -1.095)">
      <path
        fill="currentColor"
        d="M12.3 3.1c5.5 0 10 4.5 10 10s-4.5 10-10 10-10-4.5-10-10 4.4-10 10-10z"
      ></path>
      <path
        fill="white"
        d="M20.7 4.6C16-.1 8.4-.1 3.7 4.6s-4.7 12.3 0 17c4.7 4.7 12.3 4.7 17 0 4.7-4.7 4.7-12.3 0-17zM19.5 20c-.9-1.9-5.2-3.1-7.3-3.1S6 18.2 5.1 20.1C1.3 16.2 1.3 9.8 5.3 6s10.3-3.8 14.1.1c3.8 3.8 3.8 10 .1 13.9z"
      ></path>
      <path
        fill="white"
        d="M12.2 9.1c-1.8 0-3.2 1.5-3.2 3.2v.1c0 1.8 1.5 3.2 3.3 3.2s3.2-1.5 3.2-3.3c0-1.8-1.5-3.2-3.3-3.2z"
      ></path>
      <path
        fill="currentColor"
        d="M16.1 19.1h1.2v2.4h2.4v1.2h-2.4v2.4h-1.2v-2.4h-2.4v-1.2h2.4v-2.4z"
      ></path>
    </g>
  `,
});

const eyeShow = new TeSvg({
  path: svg`
    <path
      fill="currentColor"
      d="M12,3.57C6.55,3.57,1.89,7,0,11.85c1.89,4.84,6.55,8.28,12,8.28c5.45,0,10.11-3.43,12-8.28
    C22.11,7,17.45,3.57,12,3.57L12,3.57z M12.11,17.23c-2.98,0-5.4-2.45-5.4-5.46c0-3.02,2.42-5.47,5.4-5.47c2.98,0,5.4,2.45,5.4,5.47
    C17.52,14.78,15.1,17.23,12.11,17.23L12.11,17.23z M12.11,8.49c-1.79,0-3.24,1.46-3.24,3.28s1.45,3.28,3.24,3.28
    c1.79,0,3.24-1.46,3.24-3.28S13.91,8.49,12.11,8.49L12.11,8.49z"
    ></path>
  `,
});

const eyeHide = new TeSvg({
  path: svg`
    <path
      fill="currentColor"
      d="M12.01,5.91c3.01,0,5.46,2.44,5.46,5.44c0,0.71-0.14,1.37-0.39,1.99l3.19,3.18c1.65-1.37,2.95-3.15,3.74-5.17
    c-1.89-4.78-6.55-8.17-12.01-8.17c-1.53,0-2.99,0.27-4.34,0.76l2.36,2.35C10.63,6.05,11.3,5.91,12.01,5.91L12.01,5.91z M1.09,2.94
    l2.99,2.98C2.27,7.33,0.85,9.2,0,11.36c1.89,4.78,6.55,8.17,12.01,8.17c1.69,0,3.31-0.33,4.78-0.91l0.46,0.46l3.2,3.18l1.39-1.38
    L2.48,1.56L1.09,2.94L1.09,2.94z M7.13,8.96l1.69,1.69c-0.05,0.23-0.09,0.47-0.09,0.71c0,1.81,1.46,3.27,3.27,3.27
    c0.24,0,0.48-0.03,0.71-0.09l1.69,1.69c-0.73,0.36-1.54,0.58-2.4,0.58c-3.01,0-5.46-2.44-5.46-5.44C6.55,10.5,6.77,9.69,7.13,8.96
    L7.13,8.96z M11.83,8.11l3.44,3.43l0.02-0.17c0-1.81-1.46-3.27-3.27-3.27L11.83,8.11L11.83,8.11z"
    ></path>
  `,
});

const snapshot = new TeSvg({
  path: svg`
    <path
      fill="currentColor"
      d="M19.4,19.62H5c-0.96,0.03-1.77-0.73-1.8-1.69V7.76C3.23,6.8,4.04,6.04,5,6.07h2.85L9.5,4.38h5.4
    l1.65,1.69h2.85c0.96-0.03,1.77,0.73,1.8,1.69v10.16C21.17,18.89,20.37,19.65,19.4,19.62z M12.2,6.38c-2.17-0.03-3.96,1.7-4,3.87
    c0,2.86,2.98,7.01,4,7.03h0.01c0.49,0,1.49-1.02,2.37-2.43c0.92-1.37,1.47-2.95,1.62-4.6C16.16,8.07,14.37,6.34,12.2,6.38z
    M12.2,11.62c-0.76-0.03-1.36-0.66-1.34-1.43s0.66-1.36,1.43-1.34c0.74,0.02,1.34,0.64,1.34,1.38
    C13.62,11.02,12.98,11.64,12.2,11.62z"
    ></path>
  `,
});

const newDocument = new TeSvg({
  path: svg`
    <path
      d="M14.85 0H4.92C3.55 0 2.45 1.08 2.45 2.4l-.01 19.2c0 1.32 1.1 2.4 2.47 2.4h14.91c1.37 0 2.48-1.08 2.48-2.4V7.2L14.85 0zm2.48 16.8h-3.72v3.6h-2.48v-3.6H7.4v-2.4h3.72v-3.6h2.48v3.6h3.72v2.4h.01zm-3.72-8.4V1.8l6.83 6.6h-6.83z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill="currentColor"
    ></path>
  `,
});

const trashbin = new TeSvg({
  path: svg`
    <path
      d="M3.77 17.08V5.32h16.46v16.01A2.717 2.717 0 0117.49 24h-6.8l-6.92-6.92zM10.69 24H6.51a2.723 2.723 0 01-2.74-2.67v-4.25L10.69 24zM2.4 4V1.33h4.8L8.57 0h6.86l1.37 1.33h4.8V4H2.4z"
      fill="currentColor"
    ></path>
  `,
});

const download = new TeSvg({
  path: svg`
    <path
      d="M12.414 5.294H8.867V0h-5.32v5.294H0l6.207 6.176 6.207-6.176zM0 13.235V15h12.414v-1.765z"
      fill="currentColor"
      fillRule="evenodd"
    ></path>
  `,
});

const print = new TeSvg({
  path: svg`
    <g id="prefix__print" transform="translate(-776.17 -136.17)">
      <g id="prefix__print-2" transform="translate(776.17 135.17)">
        <path
          id="prefix__Path_331"
          fill="currentColor"
          className="prefix__st0"
          d="M16.98 7.89v-.87c.02-1.03-.8-1.89-1.83-1.91H9.48c-1.03.02-1.85.87-1.83 1.91v.87h9.33z"
        ></path>
        <path
          id="prefix__Path_332"
          fill="currentColor"
          className="prefix__st0"
          d="M18.48 8.58H6.15a1.88 1.88 0 00-1.83 1.91v4.52c-.02 1.03.8 1.89 1.83 1.91h.83v-2.96c-.01-.66.51-1.2 1.17-1.22h8.33c.66.01 1.18.56 1.17 1.22v2.96h.83c1.03-.02 1.85-.88 1.83-1.91v-4.52c.03-1.03-.79-1.88-1.83-1.91z"
        ></path>
        <path
          id="prefix__Path_333"
          fill="currentColor"
          className="prefix__st0"
          d="M16.48 13.45H8.15c-.28.01-.51.24-.5.52v5.22c-.02 1.03.8 1.89 1.83 1.91h5.67c1.03-.02 1.85-.88 1.83-1.91v-5.22a.512.512 0 00-.5-.52zm-6.33 2.44h4.33c.29.01.51.26.5.54-.01.27-.23.49-.5.5h-4.33a.523.523 0 01-.5-.54c.01-.28.23-.49.5-.5zm2.33 3.13h-2.33a.523.523 0 01-.5-.54c.01-.27.23-.49.5-.5h2.33c.29.01.51.26.5.54a.53.53 0 01-.5.5z"
        ></path>
      </g>
    </g>
  `,
});

const scheduleDate = new TeSvg({
  path: svg`
    <path
      id="calendar"
      fill="currentColor"
      d="M17.76,5.1H6.87c-0.85,0-1.55,0.69-1.55,1.55c0,0,0,0.01,0,0.01L5.32,17.55
    c0,0.86,0.7,1.56,1.55,1.56c0,0,0,0,0,0h10.89c0.86,0,1.55-0.7,1.56-1.56V6.66C19.31,5.8,18.62,5.11,17.76,5.1 M6.87,8.99h10.89
    v8.56H6.87 M8.43,10.55h3.89v3.89H8.43"
    ></path>
  `,
});

const undo = new TeSvg({
  path: svg`
    <path
      d="M4.22 10.92c2.22-2 5.1-3.1 8.09-3.11 5.36.03 10.08 3.52 11.68 8.63l-2.77.93a9.4 9.4 0 00-8.91-6.57c-2.2.01-4.33.81-6 2.25l4.24 4.33H0V6.62l4.22 4.3"
      fillRule="evenodd"
      clipRule="evenodd"
      fill="currentColor"
    ></path>
  `,
});

const block = new TeSvg({
  path: svg`
    <circle
      cx=12.11
      cy=11.89
      r=10.62
      fill="none"
      stroke="currentColor"
      strokeWidth=2
    ></circle>
    <path fill="currentColor" d="M5.31 10.19H18.9v3.4H5.31z" ></path>
  `,
});

const inInspection = new TeSvg({
  path: svg`
    <g>
      <g>
        <g>
          <g>
            <path
              fill="currentColor"
              d="M14.9,4.3c2.6,0,4.7,2.1,4.7,4.7s-2.1,4.7-4.7,4.7c-0.9,0-1.8-0.3-2.5-0.7l0,0c0,0,0,0,0,0
            c0.2-0.2,0.3-0.4,0.3-0.6c0.6,0.4,1.4,0.6,2.2,0.6c2.2,0,4-1.8,4-4s-1.8-4-4-4s-4,1.8-4,4c0,0.8,0.2,1.6,0.6,2.2
            c-0.3,0-0.5,0.1-0.7,0.3l0,0c-0.5-0.7-0.7-1.6-0.7-2.5C10.2,6.5,12.3,4.3,14.9,4.3z"
            ></path>
            <path
              fill="currentColor"
              d="M12.8,12.3C12.8,12.3,12.8,12.4,12.8,12.3c-0.5-0.2-0.9-0.6-1.2-1c0.3,0,0.6,0,0.8,0.3c0,0,0,0,0,0
            C12.6,11.8,12.8,12,12.8,12.3z"
            ></path>
            <path
              fill="currentColor"
              d="M12.8,12.4c0,0.2-0.1,0.5-0.3,0.6c0,0,0,0,0,0l0,0c-0.6-0.4-1.1-0.9-1.5-1.5l0,0c0.2-0.2,0.4-0.3,0.7-0.3
            C11.9,11.7,12.3,12.1,12.8,12.4z"
            ></path>
            <path
              fill="currentColor"
              d="M12.4,13.1l-5.8,6.1c-0.5,0.5-1.3,0.5-1.8,0c0,0,0,0,0,0c-0.3-0.3-0.4-0.6-0.4-0.9c0-0.3,0.1-0.6,0.4-0.9
            c0,0,0,0,0,0l6.1-5.8C11.3,12.2,11.8,12.7,12.4,13.1z"
            ></path>
          </g>
          <g>
            <path
              fill="none"
              stroke="currentColor"
              d="M10.9,11.6c-0.5-0.7-0.7-1.6-0.7-2.5c0-2.6,2.1-4.7,4.7-4.7c2.6,0,4.7,2.1,4.7,4.7s-2.1,4.7-4.7,4.7
            c-0.9,0-1.8-0.3-2.5-0.7C11.8,12.7,11.3,12.2,10.9,11.6z"
            ></path>
            <path
              fill="none"
              stroke="currentColor"
              d="M11.6,11.3c-0.4-0.6-0.6-1.4-0.6-2.2c0-2.2,1.8-4,4-4s4,1.8,4,4s-1.8,4-4,4c-0.8,0-1.5-0.2-2.2-0.6
            C12.3,12.1,11.9,11.7,11.6,11.3z"
            ></path>
          </g>
        </g>
      </g>
    </g>
  `,
});

const hasIssues = new TeSvg({
  path: svg`
    <path
      fill="currentColor"
      d="M13.1,6.1l-0.2,7.6c0,0.5-0.4,1-0.9,1c0,0,0,0,0,0l0,0c-0.5,0-0.9-0.4-0.9-1
      c0,0,0,0,0,0l-0.2-7.6c0-0.6,0.5-1.1,1.1-1.2c0,0,0,0,0,0l0,0C12.6,5,13.1,5.5,13.1,6.1C13.1,6.1,13.1,6.1,13.1,6.1z M12,19
      c-0.7,0-1.2-0.6-1.2-1.3c0-0.7,0.6-1.2,1.3-1.2c0.6,0,1.2,0.6,1.2,1.2C13.2,18.5,12.6,19,12,19C12,19,12,19,12,19L12,19z"
    ></path>
  `,
});

const verified = new TeSvg({
  path: svg`
    <path
      fill="currentColor"
      d="M19.4,7.6l-1.2-1.3c0-0.1-0.1-0.1-0.2-0.1l0,0c-0.1,0-0.1,0-0.2,0.1l-8.4,8.5l-3.1-3.1
      c-0.1-0.1-0.3-0.1-0.4,0c0,0,0,0,0,0L4.6,13c-0.1,0.1-0.1,0.3,0,0.4c0,0,0,0,0,0l3.9,3.9c0.2,0.2,0.5,0.4,0.8,0.4
      c0.3,0,0.6-0.2,0.8-0.4l0,0L19.4,8C19.5,7.9,19.5,7.7,19.4,7.6z"
    ></path>
  `,
});

const dragHandle = new TeSvg({
  path: svg`
    <g transform="translate(-245 -22)">
      <path
        fill="currentColor"
        d="M254,22c0.8,0,1.5,0.7,1.5,1.5v21c0,0.8-0.7,1.5-1.5,1.5s-1.5-0.7-1.5-1.5v-21
        C252.5,22.7,253.2,22,254,22z"
      ></path>
      <path
        fill="currentColor"
        d="M260,22c0.8,0,1.5,0.7,1.5,1.5v21c0,0.8-0.7,1.5-1.5,1.5s-1.5-0.7-1.5-1.5v-21
        C258.5,22.7,259.2,22,260,22z"
      ></path>
    </g>
  `,
});

const listView = new TeSvg({
  path: svg`
    <g transform="translate(-4.5 -7.313)">
      <path
        fill="currentColor"
        d="M8,19.3c0,1-0.8,1.7-1.7,1.7c-1,0-1.7-0.8-1.7-1.7s0.8-1.7,1.7-1.7h0C7.2,17.6,8,18.3,8,19.3z"
      ></path>
      <path
        fill="currentColor"
        d="M8,11.6c0,1-0.8,1.8-1.7,1.8s-1.8-0.8-1.8-1.7c0-1,0.8-1.8,1.7-1.8C7.2,9.8,8,10.6,8,11.6
      L8,11.6z"
      ></path>
      <path
        fill="currentColor"
        d="M8,27.1c0,1-0.8,1.7-1.7,1.7S4.5,28,4.5,27.1c0-1,0.8-1.7,1.7-1.7C7.2,25.3,8,26.1,8,27.1
      L8,27.1z"
      ></path>
      <path
        fill="currentColor"
        d="M27.5,18.3h-15c-0.6,0-1,0.4-1,1s0.4,1,1,1c0,0,0,0,0,0h15c0.6,0,1-0.4,1-1
      C28.5,18.8,28.1,18.3,27.5,18.3C27.5,18.3,27.5,18.3,27.5,18.3z"
      ></path>
      <path
        fill="currentColor"
        d="M27.5,26.1h-15c-0.6,0-1,0.4-1,1c0,0.6,0.4,1,1,1l0,0h15c0.6,0,1-0.4,1-1
      C28.5,26.5,28.1,26.1,27.5,26.1z"
      ></path>
      <path
        fill="currentColor"
        d="M12.5,12.6h15c0.6,0,1-0.4,1-1c0-0.6-0.4-1-1-1h-15c-0.6,0-1,0.4-1,1
      C11.5,12.1,11.9,12.6,12.5,12.6L12.5,12.6z"
      ></path>
    </g>
  `,
});

const copyCode = new TeSvg({
  path: svg`
  <path
  d="M16.91 0H3.82c-1.2 0-2.18.98-2.18 2.18v15.27h2.18V2.18h13.09V0zm3.27 4.36h-12C6.98 4.37 6 5.34 6 6.55v15.27c0 1.2.98 2.18 2.18 2.18h12c1.2 0 2.18-.98 2.18-2.18V6.55c0-1.21-.97-2.18-2.18-2.19zm0 17.46h-12V6.55h12v15.27z"
  fill="currentColor"
/>
  `,
});

const info = new TeSvg({
  path: svg`
  <path
  d="M12,0C5.37,0,0,5.37,0,12s5.37,12,12,12s12-5.37,12-12S18.63,0,12,0z M13.1,17.54h-2.21V9.23h2.21
	  V17.54z M12,8.32c-0.64-0.03-1.13-0.56-1.1-1.2s0.56-1.13,1.2-1.1c0.62,0.03,1.1,0.53,1.1,1.15c0,0.64-0.52,1.15-1.16,1.15
	  C12.02,8.32,12.01,8.32,12,8.32L12,8.32z"
  fill="currentColor"
  />
  `,
});

const cloud = new TeSvg({
  path: svg`
  <path d="M20.48,10.77c-0.42-3.86-3.88-6.65-7.74-6.23c-2.03,0.22-3.86,1.31-5.02,2.99 c-0.4-0.16-0.83-0.25-1.26-0.25c-1.86,0.07-3.33,1.58-3.35,3.44C1.24,11.36-0.01,13.11,0,15.07c-0.01,2.39,1.87,4.35,4.26,4.43 h15.47c2.43-0.08,4.34-2.11,4.27-4.55C23.93,12.92,22.48,11.19,20.48,10.77L20.48,10.77z"
  fill="currentColor" />
  `,
});

const columns = new TeSvg({
  path: svg`
  <g id="icon-column-g" transform="translate(0 0)">
	<path id="bottom-right-square" class="st0" d="M17.4,0h4.35C22.99,0,24,1.01,24,2.25v19.5c0,1.24-1.01,2.25-2.25,2.25l0,0H17.4l0,0
		V0L17.4,0z" fill="currentColor"/>
	<path id="bottom-left-square" class="st0" d="M2.25,0H6.6l0,0v24l0,0H2.25C1.01,24,0,22.99,0,21.75l0,0V2.25C0,1.01,1.01,0,2.25,0z
		" fill="currentColor"/>
	<rect id="bottom-left-square-2" x="8.7" y="0" class="st0" width="6.6" height="24" fill="currentColor"/>
</g>
  `,
});

const gallery = new TeSvg({
  path: svg`
 <path id="top-left-square" class="st0" d="M3,0h3.6c1.66,0,3,1.34,3,3v3.6c0,1.66-1.34,3-3,3H3c-1.66,0-3-1.34-3-3V3
	C0,1.34,1.34,0,3,0z" fill="currentColor"/>
<path id="top-right-square" class="st0" d="M17.4,0H21c1.66,0,3,1.34,3,3v3.6c0,1.66-1.34,3-3,3h-3.6c-1.66,0-3-1.34-3-3V3
	C14.4,1.34,15.74,0,17.4,0z" fill="currentColor"/>
<path id="bottom-right-square" class="st0" d="M17.4,14.4H21c1.66,0,3,1.34,3,3V21c0,1.66-1.34,3-3,3h-3.6c-1.66,0-3-1.34-3-3v-3.6
	C14.4,15.74,15.74,14.4,17.4,14.4z" fill="currentColor"/>
<path id="bottom-left-square" class="st0" d="M3,14.4h3.6c1.66,0,3,1.34,3,3V21c0,1.66-1.34,3-3,3H3c-1.66,0-3-1.34-3-3v-3.6
	C0,15.74,1.34,14.4,3,14.4z" fill="currentColor"/>
  `,
});

const indeterminateCheckmark = new TeSvg({
  path: svg`
    <path
      d="M2 10h20c1.1 0 2 .9 2 2s-.9 2-2 2H2c-1.1 0-2-.9-2-2s.9-2 2-2z"
      fill="currentColor"
    />
    `,
});

const location = new TeSvg({
  path: svg`
<path id="Icon_material-location-on" class="st0" d="M12,0C7.36,0,3.6,3.76,3.6,8.4c0,0,0,0,0,0C3.6,14.7,12,24,12,24
	s8.4-9.3,8.4-15.6C20.4,3.76,16.64,0,12,0L12,0z M12,11.4c-1.66,0-3-1.34-3-3s1.34-3,3-3s3,1.34,3,3S13.66,11.4,12,11.4z" fill="currentColor"/>
  `,
});

const complete = new TeSvg({
  path: svg`
<path id="Icon_ionic-ios-checkmark-circle" class="st0" d="M12,0C5.37,0,0,5.37,0,12s5.37,12,12,12s12-5.37,12-12S18.63,0,12,0z
	 M18.15,8.68l-7.71,7.75l0,0c-0.18,0.18-0.41,0.3-0.67,0.32c-0.26-0.02-0.5-0.14-0.67-0.33l-3.24-3.23c-0.09-0.09-0.09-0.23,0-0.32
	c0,0,0,0,0,0l1.03-1.03c0.09-0.09,0.23-0.09,0.32-0.01c0,0,0,0,0.01,0.01l2.56,2.56L16.8,7.3c0.04-0.04,0.1-0.07,0.16-0.07l0,0
	c0.06,0,0.12,0.02,0.16,0.07l1.01,1.05C18.23,8.44,18.23,8.58,18.15,8.68C18.15,8.68,18.15,8.68,18.15,8.68L18.15,8.68z" fill="currentColor"/>
  `,
});

const users = new TeSvg({
  path: svg`
<path id="Icon_awesome-user-circle" class="st0" d="M12,0C5.37,0,0,5.37,0,12s5.37,12,12,12s12-5.37,12-12l0,0C24,5.37,18.63,0,12,0
	z M12,4.65c2.35,0,4.26,1.91,4.26,4.26s-1.91,4.26-4.26,4.26c-2.35,0-4.26-1.91-4.26-4.26c0,0,0,0,0,0C7.74,6.55,9.65,4.65,12,4.65
	C12,4.64,12,4.64,12,4.65L12,4.65z M12,21.3c-2.73,0-5.33-1.21-7.09-3.3c0.93-1.77,2.76-2.89,4.77-2.89c0.12,0,0.23,0.02,0.34,0.05
	c0.64,0.21,1.31,0.32,1.98,0.32c0.67-0.01,1.34-0.12,1.98-0.33c0.11-0.03,0.23-0.05,0.34-0.05c2,0.01,3.84,1.12,4.77,2.89
	c-1.76,2.09-4.35,3.3-7.09,3.3V21.3z" fill="currentColor"/>
  `,
});

const configure = new TeSvg({
  path: svg`
  <path id="Icon_ionic-ios-cog" class="st0" d="M23.57,11.2l-1.5-0.24c-0.2-0.03-0.35-0.19-0.38-0.4c-0.03-0.19-0.06-0.37-0.1-0.55
	c-0.04-0.2,0.05-0.4,0.23-0.5l1.33-0.75c0.21-0.11,0.31-0.36,0.23-0.58l-0.23-0.64c-0.08-0.22-0.31-0.35-0.54-0.29l-1.5,0.29
	c-0.2,0.04-0.4-0.06-0.5-0.24c-0.09-0.16-0.18-0.33-0.28-0.49c-0.11-0.17-0.09-0.4,0.04-0.55l1-1.16c0.16-0.17,0.17-0.44,0.02-0.62
	l-0.43-0.53c-0.15-0.18-0.41-0.22-0.6-0.09l-1.31,0.79c-0.17,0.1-0.39,0.08-0.54-0.05c-0.14-0.12-0.28-0.24-0.43-0.36
	c-0.16-0.12-0.22-0.34-0.15-0.53l0.54-1.44c0.09-0.22,0.01-0.47-0.19-0.59l-0.59-0.34c-0.2-0.12-0.46-0.06-0.6,0.13l-0.96,1.21
	c-0.11,0.16-0.31,0.22-0.49,0.15c0,0-0.32-0.13-0.57-0.22c-0.19-0.06-0.32-0.25-0.32-0.46l0.02-1.54c0.01-0.24-0.15-0.45-0.38-0.49
	l-0.67-0.12c-0.23-0.04-0.46,0.1-0.53,0.33l-0.5,1.46c-0.07,0.19-0.25,0.32-0.45,0.32c-0.09,0-0.19,0-0.28,0c-0.09,0-0.19,0-0.28,0
	c-0.2,0-0.38-0.12-0.45-0.32l-0.5-1.46c-0.07-0.23-0.29-0.37-0.53-0.33L9.55,0.12C9.32,0.17,9.17,0.38,9.18,0.61L9.2,2.15
	c0.01,0.21-0.12,0.39-0.32,0.46L8.33,2.82C8.14,2.88,7.94,2.82,7.82,2.66L6.87,1.46c-0.14-0.19-0.4-0.25-0.6-0.13L5.68,1.68
	C5.47,1.79,5.39,2.05,5.49,2.27l0.54,1.44C6.1,3.9,6.04,4.12,5.88,4.24C5.73,4.36,5.59,4.48,5.45,4.6C5.3,4.74,5.08,4.76,4.91,4.66
	l-1.28-0.8c-0.19-0.13-0.45-0.09-0.6,0.09L2.58,4.46C2.43,4.65,2.44,4.91,2.6,5.08l1,1.16C3.73,6.4,3.74,6.62,3.64,6.8
	c-0.1,0.16-0.19,0.32-0.28,0.49c-0.1,0.18-0.3,0.28-0.5,0.24l-1.48-0.3C1.15,7.18,0.92,7.3,0.84,7.52L0.61,8.17
	C0.53,8.39,0.62,8.64,0.83,8.74l1.33,0.75c0.18,0.1,0.27,0.3,0.23,0.5c-0.03,0.19-0.07,0.37-0.1,0.55c-0.03,0.2-0.18,0.36-0.38,0.4
	l-1.5,0.24c-0.23,0.03-0.4,0.22-0.41,0.46v0.68c0,0.24,0.18,0.43,0.41,0.46l1.5,0.24c0.2,0.03,0.35,0.19,0.38,0.4
	c0.03,0.19,0.06,0.37,0.1,0.55c0.04,0.2-0.05,0.4-0.23,0.5l-1.33,0.75c-0.21,0.11-0.31,0.36-0.23,0.58l0.23,0.64
	c0.08,0.22,0.31,0.35,0.54,0.29l1.5-0.29c0.2-0.04,0.4,0.06,0.5,0.24c0.09,0.16,0.18,0.33,0.28,0.49c0.11,0.17,0.09,0.4-0.04,0.55
	l-1,1.16c-0.18,0.17-0.19,0.45-0.04,0.64l0.43,0.53c0.15,0.18,0.41,0.22,0.6,0.09l1.31-0.79c0.17-0.1,0.39-0.08,0.54,0.05
	c0.14,0.12,0.28,0.24,0.43,0.36c0.16,0.12,0.22,0.34,0.15,0.53L5.5,21.74c-0.09,0.22-0.01,0.47,0.19,0.59l0.59,0.34
	c0.2,0.12,0.46,0.06,0.6-0.13l0.97-1.2c0.11-0.15,0.3-0.21,0.47-0.15c0.2,0.08,0.33,0.13,0.57,0.21c0.19,0.06,0.32,0.25,0.32,0.46
	l-0.02,1.53c-0.01,0.24,0.15,0.45,0.38,0.49l0.67,0.12c0.23,0.04,0.46-0.1,0.53-0.33l0.5-1.46c0.07-0.19,0.25-0.32,0.45-0.32
	c0.09,0,0.19,0,0.28,0c0.09,0,0.19,0,0.28,0c0.2,0,0.38,0.12,0.45,0.32l0.5,1.46c0.07,0.23,0.29,0.37,0.53,0.33l0.67-0.12
	c0.23-0.04,0.39-0.25,0.38-0.49l-0.02-1.54c-0.01-0.21,0.12-0.39,0.32-0.46c0.24-0.08,0.4-0.15,0.55-0.2
	c0.17-0.07,0.37-0.02,0.48,0.12l0.98,1.21c0.14,0.19,0.4,0.25,0.6,0.13l0.59-0.34c0.21-0.12,0.29-0.37,0.19-0.59l-0.54-1.44
	c-0.07-0.19-0.01-0.41,0.15-0.53c0.15-0.12,0.29-0.24,0.43-0.36c0.15-0.14,0.37-0.16,0.54-0.05l1.31,0.79
	c0.19,0.13,0.45,0.09,0.6-0.09l0.43-0.53c0.15-0.18,0.14-0.45-0.02-0.62l-1-1.16c-0.13-0.16-0.15-0.38-0.04-0.55
	c0.1-0.16,0.19-0.32,0.28-0.49c0.1-0.18,0.3-0.28,0.5-0.24l1.5,0.29c0.23,0.05,0.46-0.07,0.54-0.29l0.23-0.64
	c0.08-0.22-0.02-0.47-0.23-0.58l-1.33-0.75c-0.18-0.1-0.27-0.3-0.23-0.5c0.03-0.19,0.07-0.37,0.1-0.55c0.03-0.2,0.18-0.36,0.38-0.4
	l1.5-0.24c0.23-0.03,0.4-0.22,0.41-0.46v-0.68C23.98,11.41,23.8,11.22,23.57,11.2z M7.71,17.89c-0.26,0.45-0.83,0.6-1.27,0.34
	c-0.06-0.04-0.12-0.08-0.17-0.13c-3.33-3.2-3.46-8.53-0.3-11.89c0.09-0.1,0.18-0.19,0.28-0.28C6.62,5.57,7.2,5.58,7.56,5.96
	c0.05,0.05,0.1,0.11,0.13,0.18l3.23,5.64c0.08,0.15,0.08,0.32,0,0.47L7.71,17.89z M20.06,13.97c-1.08,4.52-5.57,7.29-10.03,6.2
	c-0.13-0.03-0.26-0.07-0.38-0.1c-0.49-0.14-0.77-0.66-0.63-1.15c0.02-0.07,0.05-0.15,0.09-0.21l3.21-5.66
	c0.08-0.14,0.23-0.23,0.4-0.23h6.44c0.51,0,0.92,0.41,0.93,0.92C20.09,13.82,20.08,13.9,20.06,13.97L20.06,13.97z M19.16,11.19
	h-6.45c-0.16,0-0.32-0.09-0.4-0.23L9.09,5.31C8.83,4.86,8.98,4.29,9.42,4.03c0.06-0.04,0.13-0.07,0.2-0.09
	c4.41-1.32,9.04,1.23,10.34,5.69c0.04,0.13,0.07,0.26,0.11,0.4c0.12,0.5-0.18,1-0.67,1.13C19.32,11.18,19.24,11.19,19.16,11.19
	L19.16,11.19z" fill="currentColor"/>
  `,
});

const warning = new TeSvg({
  path: svg`
    <path
     d="M0 22.5h24l-12-21-12 21zm13.29-3.23h-2.57v-2.42h2.57v2.42zm0-4.04h-2.57v-4.84h2.57v4.84z"
      fill="currentColor"
    />
    `,
});

export const pathByName = {
  'drag-right': dragRight,
  'angled-menu': angledMenu,
  'chevron-left': chevronLeft,
  'chevron-right': chevronRight,
  'chevron-up': chevronUp,
  'chevron-down': chevronDown,
  'arrow-right': arrowRight,
  'arrow-left': arrowLeft,
  'arrow-up-circle': arrowUpCircle,
  'triangle-left': triangleLeft,
  'triangle-right': triangleRight,
  'triangle-up': triangleUp,
  'triangle-down': triangleDown,
  'map-pin': mapPin,
  'user-add': userAdd,
  'upload-thin': uploadThin,
  'upload-error': uploadError,
  'more-items': moreItems,
  'more-items-vertical': moreItemsVertical,
  'schedule-add': scheduleAdd,
  'schedule-list': scheduleList,
  'schedule-stack': scheduleStack,
  'site-contacts': siteContacts,
  'eye-show': eyeShow,
  'eye-hide': eyeHide,
  'schedule-date': scheduleDate,
  'sites-landscape': sitesLandscape,
  'sites-grid': sitesGrid,
  'in-inspection': inInspection,
  'has-issues': hasIssues,
  'drag-handle': dragHandle,
  'copy-code': copyCode,
  'indeterminate-checkmark': indeterminateCheckmark,
  location,
  users,
  configure,
  complete,
  info,
  verified,
  bell,
  checkmark,
  checkmarkcircle,
  pageNotFound,
  resources,
  close,
  delete: del,
  edit,
  editPolygon,
  expand,
  collapse,
  filter,
  grid,
  layers,
  map,
  menu,
  milestone,
  minus,
  pdf,
  pentagon,
  plus,
  point,
  polygon,
  addSubAreaPolygon,
  editSubAreaPolygon,
  schedule,
  search,
  share,
  tiff,
  upload,
  user,
  cloudUp,
  resize,
  link,
  contacts,
  image,
  snapshot,
  newDocument,
  trashbin,
  download,
  print,
  block,
  undo,
  listView,
  previous,
  next,
  cloud,
  columns,
  gallery,
  list,
  warning,
};
